function quarticInOut(t) {
  return t < 0.5
    ? +8.0 * Math.pow(t, 4.0)
    : -8.0 * Math.pow(t - 1.0, 4.0) + 1.0
}

module.exports = quarticInOut


//////////////////
// WEBPACK FOOTER
// ./~/eases/quart-in-out.js
// module id = 152
// module chunks = 0